export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/yelp.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/facebook.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/zomato.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusionlisa/image/upload/v1615597617/mtfuji/mobileContactbg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1585671918/cafesaladedefruits/saladedefruits_instagram.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1590261442/general/cflogo.png'

export const about = 'https://d2r2uhcogw3v36.cloudfront.net/about.webp'
export const contactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1640903479/onesushi/contactBg.jpg'

export const foodGallery =
  'https://d2r2uhcogw3v36.cloudfront.net/foodGallery.webp'
export const hero = 'https://d2r2uhcogw3v36.cloudfront.net/hero.jpg'
export const heroText =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1640903644/onesushi/heroText.png'
export const orderDeliveryButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1559336415/Applause/downloadButton.png'
export const orderPickupButton =
  'https://res.cloudinary.com/codefusionlisa/image/upload/f_auto,q_auto/v1615597530/mtfuji/orderPickupButton.png'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1640905474/onesushi/mobileContact.jpg'
export const mobileMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1640905336/onesushi/mobileMap.jpg'
export const homebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1561913154/Applause/woodbg.jpg'
export const logo =
  'https://res.cloudinary.com/codefusionlisa/image/upload/f_auto,q_auto/v1615597857/mtfuji/logo.png'
export const logoTitle =
  'https://res.cloudinary.com/codefusionlisa/image/upload/f_auto,q_auto/v1615597857/mtfuji/logoTitle.png'
export const locationMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1640903479/onesushi/locationMap.jpg'
export const promotions = 'https://d2r2uhcogw3v36.cloudfront.net/promo.webp'
export const mobileHero =
  'https://d2r2uhcogw3v36.cloudfront.net/mobileHero2.webp'
export const mobilePromotion =
  'https://d2r2uhcogw3v36.cloudfront.net/mobilePromo.webp'
export const mobileAbout =
  'https://d2r2uhcogw3v36.cloudfront.net/mobileAbout.webp'
export const mobileGallery =
  'https://d2r2uhcogw3v36.cloudfront.net/mobileGallery.webp'
export const mobilePromo1 =
  'https://d2r2uhcogw3v36.cloudfront.net/mobilePromo1.jpg'
export const mobilePromo2 =
  'https://d2r2uhcogw3v36.cloudfront.net/mobilePromo2.jpg'
export const mobilePromo3 =
  'https://d2r2uhcogw3v36.cloudfront.net/mobilePromo3.jpeg'

export { default as promo } from './promo.png'
export { default as holiday } from './holiday.jpg'
